<template>
  <svg
    :viewBox="`0 0 ${chartOptions.width || '100'} ${chartOptions.height || '10'}`"
    :style="{ height: (chartOptions.height || '10') + 'px' }"
  >
    <!-- <g v-for="(tactic,idx) in tacticData.data" :key="idx"> -->
    <!-- <el-tooltip class="item" effect="dark" placement="top" :content="labels[idx]" :enterable="false"> -->
    <line
      v-for="(tactic, idx) in tacticData.data"
      :key="idx"
      :x1="tactic.point1.x"
      :y1="tactic.point1.y"
      :x2="tactic.point2.x"
      :y2="tactic.point2.y"
      :stroke="lineOptions.fillStyle[idx]"
      :stroke-width="lineOptions.lineWidth"
    >
      <title>{{ labels[idx] }}</title>
    </line>
    <!-- </el-tooltip> -->
    <!-- </g> -->
  </svg>
</template>

<script>
import ProgressTicksChart from "@/components/chart/ProgressTicksChart.vue";
export default {
  name: "CyberKillChainTickChart",
  extends: ProgressTicksChart,
  props: {
    chartId: { type: String },
    chartOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    chartData: { type: [Object, Array] },
    chartPlugins: { type: Object }
  },
  data() {
    return {
      tacticData: [],
      labels: [],
      lineOptions: {}
    };
  },
  methods: {
    renderChart() {
      let elWidth = this.chartOptions.width || 100;
      // Following ChartJS pattern of passing in data
      // { datasets: [{label:'', data: [], bgColor: []}], labels: []}
      this.tacticData = this.chartData.datasets ? this.chartData.datasets[0] : { data: this.chartData };

      this.labels = this.chartData.labels;

      let padding = 2;
      // calc padding between each tactic mark
      if (!_.isEmpty(this.chartOptions.padding)) {
        padding = this.chartOptions.padding;
      }

      // cal lineWidth & account for padding needed
      let lineWidth = (elWidth - padding * this.tacticData.data.length) / this.tacticData.data.length;

      // calc each point(x,y) for each line
      for (let idx = 0; idx < this.tacticData.data.length; idx++) {
        if (idx === 0) {
          // x moves with width + padding
          // y is constant (0, 10 (height))
          // safe to ignore previous data,
          // this.tacticData.backgroundColor tells us what tactic has been executed
          this.tacticData.data[idx] = {
            point1: {
              x: lineWidth / 2, // allow room for stroke width
              y: 0
            },
            point2: {
              x: lineWidth / 2,
              y: 10
            }
          };
        } else {
          this.tacticData.data[idx] = {
            point1: {
              x: this.tacticData.data[idx - 1].point1.x + lineWidth + padding,
              y: 0
            },
            point2: {
              x: this.tacticData.data[idx - 1].point2.x + lineWidth + padding,
              y: 10
            }
          };
        }
      }

      this.lineOptions = {
        fillStyle: this.tacticData.backgroundColor,
        lineWidth: lineWidth
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/chart/CyberKillChainTickChart.vue